import styled, { css } from 'styled-components';

export const PremiumInputContainer = styled.div`
  display: flex;
  height: 40px;
  padding: 4px 8px 2px 8px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  cursor: text;
  position: relative;
  /* overflow: hidden; */

  border-radius: 4px;
  border: 1px solid var(--grey200);
  background: var(--primary-background);

  input {
    background-color: transparent;
  }

  /* clears the ‘X’ from Internet Explorer */
  input[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  input[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  /* clears the ‘X’ from Chrome */
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  ${(props) =>
    !!props.width &&
    css`
      width: ${props.width};
      flex: none;
    `}

  ${(props) =>
    !props.width &&
    css`
      flex: 1 0 0;
    `}


  ${(props) =>
    !!props.isDisabled &&
    css`
      cursor: default;
      border: 1px solid var(--grey300);
      background: var(--grey200);
    `}
    ${(props) =>
    !!props.hasFocus &&
    css`
      border: 1px solid var(--primary-500);
      background: var(--primary-background);
    `}
  ${(props) =>
    !!props.hasError &&
    css`
      border: 1px solid var(--error-900);
      background: var(--error-100);
    `}
`;
